import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { numericDuration } from 'ember-stereo/helpers/numeric-duration';

export default class DeluxePlayerPositionEndTimeComponent extends Component {
  @service clock;
  @service feeds;
  @service stereo;

  get loadedFeed() {
    return this.feeds.findFeed({ url: this.args.identifier });
  }

  get loadedSound() {
    return this.stereo.findSound(this.args.identifier);
  }

  get endsAt() {
    return this.loadedFeed?.airing?.endsAt;
  }

  get timeRemaining() {
    if (this.loadedFeed.isLive) {
      let remaining =
        new Date(this.loadedFeed.airing.endsAt).getTime() -
        this.clock.date.getTime();
      return numericDuration([remaining]);
    } else if (this.loadedSound) {
      let remaining = this.loadedSound.duration - this.loadedSound.position;
      return numericDuration([remaining]);
    } else {
      return 0;
    }
  }
}
